<template>
  <div class="c-attach-role" @click.stop="close">
    <n-button v-if="user.accesses?.[0]" class="apply-btn" @click.stop="detachAccess">Отозвать</n-button>
    <n-button v-if="!user.accesses?.[0]" class="apply-btn" @click.stop="show = true">Назначить</n-button>

    <div v-if="show" class="c-add-visit">
      <n-loader :loading="$var('load')" />
      <div class="form" @click.stop>
        <div class="title main">Выберите роль</div>
        <n-select label="description" class="new-select" :data="roles" v-bind="$form.input('role', 'select')" />
        <div v-if="showBranch" class="title main">Выберите филиалы</div>
        <n-select v-if="showBranch" class="new-select" :data="branches" item-value="id" v-bind="$form.input('branch', 'select')" />
        <div v-if="showDepartment" class="title main">Выберите отделы</div>
        <n-select v-if="showDepartment" class="new-select" :data="departments" item-value="id" v-bind="$form.input('department', 'select')" />
        <div v-if="showLocationPoint" class="title main">Выберите точки контроля</div>
        <n-select v-if="showLocationPoint" class="new-select" :data="locationPoints" item-value="id" v-bind="$form.input('locationPoint', 'select')" />
        <div v-if="showPosition" class="title main">Выберите должности</div>
        <n-select v-if="showPosition" class="new-select" :data="positions" item-value="id" v-bind="$form.input('position', 'select')" />
        <div class="buttons">
          <n-button class="cancel" @click.stop="close">Отмена</n-button>
          <n-button @click.stop="apply">Применить</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import imgDone from '../../assets/done.svg'

export default {
  name: 'CAttachRole',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imgDone,
      show: false,
      roles: [],
      branches: [],
      departments: [],
      locationPoints: [],
      positions: [],
    }
  },
  computed: {
    showBranch() {
      const res = this.$form.get('role.modelType') === 'branch'
      if (res) {
        this.$form.rules({
          branch: [ 'required', ],
          role: [ 'required', ],
        })
      }

      return res
    },
    showPosition() {
      const res = this.$form.get('role.modelType') === 'position'
      if (res) {
        this.$form.rules({
          position: [ 'required', ],
          role: [ 'required', ],
        })
      }

      return res
    },
    showDepartment() {
      const res = this.$form.get('role.modelType') === 'department'
      if (res) {
        this.$form.rules({
          department: [ 'required', ],
          role: [ 'required', ],
        })
      }

      return res
    },
    showLocationPoint() {
      const res = this.$form.get('role.modelType') === 'locationPoint'
      if (res) {
        this.$form.rules({
          locationPoint: [ 'required', ],
          role: [ 'required', ],
        })
      }

      return res
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.$emit('showed')
        this.load()
        this.loadBranches()
        this.loadDepartments()
        this.loadLocationPoints()
        this.loadPositions()
        this.$form.reset()
      } else {
        this.$emit('unshowed')
      }
    },
  },
  created() {
    this.$form.init({
      role: {},
      branch: [],
      department: [],
      locationPoint: [],
      position: [],
    })
    this.$form.rules({
      role: [ 'required', ],
    })
  },
  methods: {
    close() {
      this.show = false
      this.$emit('closed')
    },
    detachAccess() {
      this.$var('load', true)
      $api.accesses.detachAccess(this.user.accesses[0].id).then(() => {
        this.close()
      }).finally(() => {
        this.$var('load', true)
      })
    },
    pluckIds(key = 'branch') {
      return $n.map(this.$form.get(key), (e) => {
        return e.id
      })
    },
    apply() {
      if (this.$form.check()) {
        this.$var('load', true)
        const data = {
          name: this.$form.get('role.name'),
          userId: this.user.id,
        }
        if (this.$form.get('role.modelType') === 'branch') {
          data.modelId = this.pluckIds()
          data.modelType = 'branch'
        }
        if (this.$form.get('role.modelType') === 'locationPoint') {
          data.modelId = this.pluckIds('locationPoint')
          data.modelType = 'locationPoint'
        }
        if (this.$form.get('role.modelType') === 'department') {
          data.modelId = this.pluckIds('department')
          data.modelType = 'department'
        }
        if (this.$form.get('role.modelType') === 'position') {
          data.modelId = this.pluckIds('position')
          data.modelType = 'position'
        }
        $api.accesses.createAccess(data).then(() => {
          this.close()
        }).finally(() => {
          this.$var('load', false)
        })
      }
    },
    load() {
      this.$var('load', true)
      $api.accesses.getRoles().all().then((response) => {
        this.roles = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadBranches() {
      this.$var('load', true)
      $api.branches.get($app.auth.user().companyId).all().then((response) => {
        this.branches = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadPositions() {
      this.$var('load', true)
      $api.positions.get($app.auth.user().companyId).all().then((response) => {
        this.positions = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadDepartments() {
      this.$var('load', true)
      $api.departments.get($app.auth.user().companyId).all().then((response) => {
        this.departments = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadLocationPoints() {
      this.$var('load', true)
      $api.locationPoints.get($app.auth.user().companyId).all().then((response) => {
        this.locationPoints = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-attach-role {
  width: 100%;
  .n-select {
    width: 100%;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  .n-select {
    margin: 15px;
  }
  .pinned-schedule {
    height: 40px;
    background-color: var(--primary);
    color: #ffffff;
    border-radius: 24px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
  }
  .pinned {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.hidden {
      opacity: 0  ;
    }
  }

  .field {
    flex: 1;
    display: flex;
    margin-bottom: 15px;
    .n-input {
      margin-left: 25px;
      min-width: 100px;
    }
    &.check-box {
      display: flex;
      align-items: center;
      width: 100%;
      .box {
        margin-right: 15px;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        border: 1px solid #000000;
      }
      .title {
        justify-content: left;
        margin-bottom: 0;
      }
    }
  }
  .schedule-list {
    width: 100%;
    max-height: 400px;
    overflow: auto;
    border-top: 2px solid #EBEBEB;
    border-bottom: 2px solid #EBEBEB;
    padding: 5px;
    margin-bottom: 15px;
    .schedule-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
      padding: 5px;
      border-radius: 4px;
      cursor: pointer;
      background-color: rgba(235, 235, 235, 0.38);
      &:last-child {
        margin-bottom: 0;
      }
      .circle {
        background-color: #EBEBEB;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        &.active {
          background-color: var(--primary);
        }
      }
    }
  }

  .c-add-visit {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.04);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    width: 100%;

    .n-button {
      background-color: var(--primary);
      color: #FFFFFF;
      border: none;
      border-radius: 12px;
      height: 48px;
      padding: 0 24px;
      &.cancel {
        background-color: #ffffff;
        color: var(--primary);
        font-weight: 700;
        border: 1px solid var(--primary);
      }

    }
  }
  .form {
    padding: 15px;
    z-index: 1001;
    min-width: 400px;
    min-height: 200px;
    border-radius: 16px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: stretch;
    .title {
      font-size: 16px;
      color: #000000;
      font-weight: 500;
      &.main {
        margin-bottom: 15px;
      }
    }
    .time-selector-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .title {
        &.danger {
          width: 100%;
          color: red;
          text-align: center;
        }
        margin-right: 15px;
        font-weight: normal;
        font-size: 14px;
        color: #000000;
      }
    }
  }

  :deep() {
    .n-button {
      &.apply-btn {
        border: none;
        width: 100%;
        text-align: left;
        min-height: 30px;
        background-color: transparent;
        color: #062D43;
        padding: 0;
        border-radius: unset;
        &:hover {
          background-color: transparent;
        }
      }
    }
  }
}
</style>
